const core = require('./core');
const axios = require('axios');
const utilities = require('../utilities');

let log = false;

//HOTFIX FOR CERT ERR
var https = require('https');
//HOTFIX FOR CERT ERR
const agent = new https.Agent({
  rejectUnauthorized: false,
});

const driverPay = (server, secret) => ({
  //Minimum amount paid to a driver for a move
  driverPayMinimum: 7,

  //Base amount included in driver base pay for every move
  driverBaseFare: 1,

  /**
   * Get the matching driver rate rule for a specific move
   * @param  {Object} move - Move object to determine which pay rate group applies
   * @param  {Object} move.lane - The lane of the move
   * @param  {Date} move.pickup_time - REQ Pickup time of move (used to lookup rate)
   * @param  {Int} move.customer_id - REQ Customer's id (used to lookup rate)
   * @param  {Int} move.lane.distance_miles - REQ Distance of lane (usd to lookup region)
   * @param  {Object} move.lane.pickup - The origin location of the lane
   * @param  {Int} move.lane.pickup.region_id - Region id (used to lookup rate)
   * @param  {Int} move.lane.origin_location_id - Location id (usd to lookup region)
   * @return {Object} Pay rate rule object with driver pay rates
   */
  getDriverRate: async function (move) {
    let region = null;
    // Try to find a region_id from the move object
    // Some lanes built on the fly do not have nested pickup/delivery locations;
    //  this is due to the lane only needing the origin and destination ids
    // If no region can be found, assume a lane is being built on the fly
    // If that is the case, do not look up a pay rate rule and instead return a null
    try {
      if (move.lane) {
        if (move.lane.pickup) {
          if (move.lane.pickup.data) {
            region = move.lane.pickup.data.region_id;
          } else {
            region = move.lane.pickup.region_id;
          }
          //Rob 6/20/22 - If the pickup region is still null, then revert to using the delivery
          // This whole check section is a mess, but I am just in here for the quick hotfix atm
          if (!region) {
            if (move.lane.delivery) {
              if (move.lane.delivery.data) {
                region = move.lane.delivery.data.region_id;
              } else {
                region = move.lane.delivery.region_id;
              }
            }
          }
        } else if (move.lane.delivery) {
          if (move.lane.delivery.data) {
            region = move.lane.delivery.data.region_id;
          } else {
            region = move.lane.delivery.region_id;
          }
        } else if (move.lane.origin_location_id) {
          if (log) console.log('Looking up region by origin location ID...');
          let foundRegion = await this.getRegionByLocationId(move.lane.origin_location_id);
          if (log) console.log('Region ID found:', foundRegion);
          region = foundRegion;
        }
      }
    } catch (err) {
      console.log('Failed to parse nested location - A pay rate rule will not be applied');
      return null;
    }

    if (!region) {
      console.log('No location detected - A pay rate rule will not be applied');
      return null;
    }

    if (log)
      console.log('Looking up pay rate rule for the following: ', '\n', {
        url: server,
        'x-hasura-admin-secret': secret,
        date: move.pickup_time,
        region: region,
        customer: move.customer_id,
        distance: move.lane.distance_miles,
      });
    try {
      return await axios({
        url: server,
        method: 'post',
        data: {
          query: getPayRateRules,
          variables: {
            date: move.pickup_time ? move.pickup_time : move.ready_by ? move.ready_by : move.createdat,
            distance: move.lane.distance_miles,
          },
        },
        headers: {
          'content-type': 'application/json',
          'x-hasura-admin-secret': secret,
        },
        //HOTFIX FOR CERT ERR
        httpsAgent: agent,
      }).then(res => {
        const response = utilities.getPropValue(res, 'data.data');
        const payRateGroups = response.payrategroups;
        // log && console.log('response:', response);
        const customerAndRegionRate = payRateGroups.find(
          ({ customer_id, region_id }) => customer_id === move.customer_id && region_id === region
        );
        if (customerAndRegionRate && Array.isArray(customerAndRegionRate.payraterules) && customerAndRegionRate.payraterules.length > 0) {
          const rate = customerAndRegionRate.payraterules[0];
          log && console.log('customerAndRegionRate', customerAndRegionRate, 'rate', rate);
          return rate;
        }
        const customerRate = payRateGroups.find(
          ({ customer_id, region_id }) => customer_id === move.customer_id && region_id === null
        );
        if (customerRate && Array.isArray(customerRate.payraterules) && customerRate.payraterules.length > 0) {
          const rate = customerRate.payraterules[0];
          log && console.log('customerRate', customerRate, 'rate', rate);
          return rate;
        }
        const regionRate = payRateGroups.find(
          ({ customer_id, region_id }) => region_id === region && customer_id === null
        );
        if (regionRate && Array.isArray(regionRate.payraterules) && regionRate.payraterules.length > 0) {
          const rate = regionRate.payraterules[0];
          log && console.log('regionRate', regionRate, 'rate', rate);
          return rate;
        }
        const defaultRate = payRateGroups.find(
          ({ customer_id, region_id }) => customer_id === null && region_id === null
        );
        if (defaultRate && Array.isArray(defaultRate.payraterules) && defaultRate.payraterules.length > 0) {
          log && console.log('defaultRate', defaultRate);
          return defaultRate.payraterules[0];
        }
        console.error('Failed to find appropriate mileage band.');
        return null;
      });
    } catch (err) {
      console.error('Failed to get rate from GQL server.');
      return null;
    }
  },

  /**
   * Get the region ID for a location by the location's ID
   *
   * @param  {int} id - The ID of the location to lookup
   * @return {int} The ID of the associated region
   */
  getRegionByLocationId: async function (id) {
    try {
      return await axios({
        url: server,
        method: 'post',
        data: {
          query: getRegionByLocId,
          variables: {
            id: id,
          },
        },
        headers: {
          'content-type': 'application/json',
          'x-hasura-admin-secret': secret,
        },
        //HOTFIX FOR CERT ERR
        httpsAgent: agent,
      }).then(res => {
        const response = utilities.getPropValue(res, 'data.data');
        if (log) console.log('response:', response);
        if (response.locations) {
          if (response.locations.length > 0) {
            return response.locations[0].region_id;
          }
        } else {
          console.log('Failed to find a location.');
          return new Error('Failed to find a location.');
        }
      });
    } catch (err) {
      console.log('Failed to post to GQL server.');
      return new Error(err);
    }
  },

  /**
   * Get the total portion of pay for a driver attributed to the total duration
   *
   * @param  {int} totalDuration - The total time in seconds (use result from getTotalDuration()), set to null if calculating from a move object
   * @param  {int} perMinuteRate - The pay per minute rate in dollars, set to null if calculating from a move object
   * @param  {Object} move - (optional) If a move object is provided, the duration and rate will be calculated on the fly
   * @param  {int} move.lane.distance_miles - (optional) distance of move in miles
   * @param  {int} move.lane.average_drive_speed_mph - (optional) average drive speed of move
   * @return {int} The driver base time pay in dollars
   */
  getDriverBaseTimePay: async function (totalDuration, perMinuteRate, move = null) {
    if (log) console.log('getDriverBaseTimePay');
    let duration = totalDuration,
      rate = perMinuteRate;
    if (log) console.log('duration:', duration, '\n', 'rate:', rate);
    if (move) {
      duration = core.getTotalDuration(move.lane.distance_miles, move.lane.average_drive_speed_mph);
      let newRate = await this.getDriverRate(move);
      if (!newRate) {
        console.log('Unable to find a matching driver rate rule');
        return 0;
      }
      rate = newRate.per_minute_rate;
      if (log) console.log('new duration:', duration, 'new rate:', rate);
    }
    if (perMinuteRate) rate = perMinuteRate;
    if (!duration || !rate) return 0;
    if (duration <= 0 || typeof duration === 'undefined') return 0;
    if (rate <= 0 || typeof rate === 'undefined') return 0;
    log && console.log('returning driver base time pay:', (duration / 60) * rate);
    return (duration / 60) * rate;
  },

  /**
   * Get the total portion of pay for a driver attributed to the miles to drive
   *
   * @param  {int} miles - The number of miles distance (ex: 6.6 mi), set to null if calculating from a move object
   * @param  {int} perMileRate - The pay per mile rate in dollars, set to null if calculating from a move object
   * @param  {Object} move - (optional) If a move object is provided, the distance and rate will be calculated on the fly
   * @param  {int} move.lane.distance_miles - (optional) distance of move in miles
   * @return {int} The driver base drive pay in dollars
   */
  getDriverBaseDrivePay: async function (miles, perMileRate, move = null) {
    if (log) console.log('getDriverBaseDrivePay');
    let distance = miles,
      rate = perMileRate;
    if (log) console.log('distance:', distance, '\n', 'rate:', rate);
    if (move) {
      distance = move.lane.distance_miles;
      let newRate = await this.getDriverRate(move);
      if (!newRate) {
        console.log('Unable to find a matching driver rate rule');
        return 0;
      }
      rate = newRate.per_mile_rate;
      if (log) console.log('new distance:', distance, 'new rate:', rate);
    }
    if (perMileRate) rate = perMileRate;
    if (!distance || !rate) return 0;
    if (distance <= 0 || typeof distance === 'undefined') return 0;
    if (rate <= 0 || typeof rate === 'undefined') return 0;
    if (log) console.log('returning driver base drive pay:', distance * rate);
    return distance * rate;
  },

  /**
   * Get the total driver base pay
   *
   * @param  {Object} move - The move object to calculate base pay from
   * @param  {Object} perMinute - Optional paramater to avoid querying rate
   * @param  {Object} perMile - Optional paramater to avoid querying rate
   * @param  {Object} baseDiscount - Optional param to use with lane builder
   * @param  {Object} laneToll - Optional param to use with lane builder
   * @return {int} The total driver base pay in dollars
   */
  // getDriverBasePay: function (miles, totalDuration, perMinuteRate, perMileRate, discount, tolls, rake) {
  getDriverBasePay: async function (move, perMinute, perMile, baseDiscount, laneToll) {
    if (log) console.log('getDriverBasePay');
    try {
      let miles = move.lane.distance_miles,
        totalDuration = core.getTotalDuration(move.lane.distance_miles, move.lane.average_drive_speed_mph),
        perMinuteRate = perMinute || move.lane.driver_pay_per_minute,
        perMileRate = perMile || move.lane.driver_pay_per_mile,
        discount = baseDiscount || move.lane.driver_base_pay_discount,
        tolls = laneToll || move.lane.tolls,
        rake = move.lane.driver_rake || 0;

      if (log)
        console.log(
          '\n',
          'miles:',
          miles,
          '\n',
          'totalDuration:',
          totalDuration,
          '\n',
          'perMinuteRate:',
          perMinuteRate,
          '\n',
          'perMileRate:',
          perMileRate,
          '\n',
          'discount:',
          discount,
          '\n',
          'tolls:',
          tolls,
          '\n',
          'rake:',
          rake,
          '\n'
        );

      // If the lane object does not have driver pay rate overrides, get rates by pay rate rule
      if (!perMinuteRate || !perMileRate) {
        let driverRate = await this.getDriverRate(move);
        if (!driverRate) {
          console.log('Unable to find a matching driver rate rule');
          return 0;
        }
        console.log('Applying pay rate rule: ', driverRate);
        if (!perMinuteRate) perMinuteRate = driverRate.per_minute_rate;
        if (!perMileRate) perMileRate = driverRate.per_mile_rate;
      }

      if (miles <= 0 || typeof miles === 'undefined') return 0;
      if (totalDuration <= 0 || typeof totalDuration === 'undefined') return 0;
      if (perMinuteRate <= 0 || typeof perMinuteRate === 'undefined') return 0;
      if (perMileRate <= 0 || typeof perMileRate === 'undefined') return 0;
      if (typeof discount === 'undefined') return 0;
      if (tolls < 0 || typeof tolls === 'undefined') return 0;
      if (rake < 0 || typeof rake === 'undefined') return 0;

      let timePay = await this.getDriverBaseTimePay(totalDuration, perMinuteRate);
      let drivePay = await this.getDriverBaseDrivePay(miles, perMileRate);
      if (log) console.log('timePay:', timePay, '\n', 'drivePay:', drivePay);

      let totalPay = (timePay + drivePay + this.driverBaseFare) * (1 - rake) - discount;
      if (log) console.log('totalPay (without tolls):', totalPay);

      log &&
        console.log(
          'driver base pay:',
          ((totalPay < this.driverPayMinimum ? this.driverPayMinimum : totalPay) + tolls).toFixed(2)
        );

      return ((totalPay < this.driverPayMinimum ? this.driverPayMinimum : totalPay) + tolls).toFixed(2);
    } catch (err) {
      if (log) console.log('Failed to calculate driver base pay:', err);
      return 0;
    }
  },

  /**
   * Get the total driver return pay
   *
   * @param  {Object} move - The move object to calculate return pay from
   * @param  {Object} perMinute - Optional perMinuteRate to avoid querying it again
   * @param  {Object} returnDiscount - Optional discount if no move
   * @return {int} - The total driver return pay in dollars
   */
  // getDriverReturnPay: function (miles, avgMph, perMinuteRate, discount) {
  getDriverReturnPay: async function (move, perMinute, returnDiscount) {
    try {
      let miles = move.lane.distance_miles,
        avgMph = move.lane.average_drive_speed_mph,
        perMinuteRate = perMinute || move.lane.driver_pay_per_minute,
        discount = returnDiscount || move.lane.driver_return_pay_discount;

      // If the lane object does not have driver pay rate overrides, get rates by pay rate rule
      if (!perMinuteRate) {
        let driverRate = await this.getDriverRate(move);
        if (!driverRate) {
          console.log('Unable to find a matching driver rate rule');
          return 0;
        }
        console.log('Applying pay rate rule: ', driverRate);
        perMinuteRate = driverRate.per_minute_rate;
      }

      if (log)
        console.log(
          'miles:',
          miles,
          '\n',
          'avgMph:',
          avgMph,
          '\n',
          'perMinuteRate:',
          perMinuteRate,
          '\n',
          'discount:',
          discount
        );

      if (miles <= 0 || typeof miles === 'undefined') return 0;
      if (avgMph <= 0 || typeof avgMph === 'undefined') return 0;
      if (perMinuteRate <= 0 || typeof perMinuteRate === 'undefined') return 0;
      if (typeof discount === 'undefined') return 0;

      let driveTime = core.getDriveTimeAsSeconds(miles, avgMph);
      if (log) console.log('driveTime:', driveTime);

      log &&
        console.log(
          'driver return pay:',
          (((driveTime + core.getReturnRideWaitTimeAsSeconds()) / 60) * perMinuteRate - discount).toFixed(2)
        );

      return (((driveTime + core.getReturnRideWaitTimeAsSeconds()) / 60) * perMinuteRate - discount).toFixed(2);
    } catch (err) {
      if (log) console.log('Failed to calculate driver return pay:', err);
      return 0;
    }
  },
});

module.exports = driverPay;

const getPayRateRules = `
query getPayRateRules($date: timestamptz!, $distance: numeric!) {
  payrategroups(where: {_and: [{active: {_eq: true}}, {begin_date: {_lte: $date}}, {end_date: {_gt: $date}}]}) {
    customer_id
    region_id
    payraterules(where: {_and: [{distance_start: {_lte: $distance}}, {distance_end: {_gt: $distance}}]}) {
      distance_start
      distance_end
      per_mile_rate
      per_minute_rate
    }
  }
}
`;

const getRegionByLocId = `
  query getRegionByLocId($id: bigint!) {
    locations(where: {id: {_eq: $id}}) {
      region_id
    }
  } 
`;
